export default __webpack_public_path__ + "static/4-572e20942954cde773096ff545ba3d25.png";